import React from "react";
import BigCalendar from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from "moment";
import moment_timezone from "moment-timezone";
import { useEffect } from "react";
moment_timezone.tz.setDefault("Europe/Zurich");

// calendar settings
const timeMin = "08:00";
const timeMax = "22:00";
const currentDate = moment().format("D MMM YYYY");
BigCalendar.momentLocalizer(moment_timezone);

// set week to start on monday
moment.locale("ko", {
  week: { dow: 1 },
});
const calendarViews = ["month", "week", "agenda"];

export default function CourseCalendar({ eventsList }) {
  useEffect(() => {
    document.querySelectorAll(".rbc-calendar button").forEach((e) => {
      e.classList.add("btn", "btn-default");
    });
  }, []);

  return (
    <BigCalendar
      events={eventsList}
      views={calendarViews}
      timeslots={4}
      min={new Date(`${currentDate}, ${timeMin}`)}
      max={new Date(`${currentDate}, ${timeMax}`)}
      defaultView="month"
    />
  );
}
